var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.155 17.82c0-.273.221-.494.494-.494h5.697c.567 0 1.027-.46 1.027-1.027V5.428c0-.568-.46-1.028-1.028-1.028H2.655c-.568 0-1.028.46-1.028 1.028v10.87c0 .568.46 1.028 1.027 1.028h5.698a.493.493 0 0 1 0 .987H5.759v.007H.4a.398.398 0 0 0-.399.399v.883c0 .22.179.398.399.398h23.203c.22 0 .398-.179.398-.398v-.883a.398.398 0 0 0-.398-.399h-5.36v-.007h-2.593a.494.494 0 0 1-.494-.493",
    fill: "#F60",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledComputer);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-computer.e890ee26aadab50182faa6ecb56b508d.svg";
export { ForwardRef as ReactComponent };